import { render } from "./CourseInstructors.vue?vue&type=template&id=9e01cc0c&scoped=true"
import script from "./CourseInstructors.vue?vue&type=script&lang=js"
export * from "./CourseInstructors.vue?vue&type=script&lang=js"

import "./CourseInstructors.vue?vue&type=style&index=0&id=9e01cc0c&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e01cc0c"]])

export default __exports__